import { path, pipe } from 'ramda';

export const getCustomer = path(['register', 'customer']);

export const getCustomerId = path(['register', 'customer', 'id']);

export const getCustomerName = path(['register', 'customer', 'name']);

export const getCustomerCard = path(['register', 'customer', 'paymentCard']);

export const getHasCustomerCard = pipe(
  getCustomerCard,
  Boolean,
);
